import { useEffect, useState } from 'react';
import Profile from './profile';
import AccountStatement from './account-statement';
import ActivityLog from './activity-log';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Modal } from 'antd';
import { TfiPencilAlt } from 'react-icons/tfi';
import { useLocation, useNavigate } from 'react-router-dom';
import { changePasswordAsync, logout } from '../../redux/slice/auth/authSlice';
import { NotificationManager } from 'react-notifications';

function MyAccount() {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { state } = useLocation()
    const profileData = useSelector((state) => state.authSlice.profileData);
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [data, setData] = useState({})
    const [openEdit, setOpenEdit] = useState(false)
    const [loading, setLoading] = useState(false)
    const [user_nameValidationError, setUser_NameValidationError] = useState("");
    const [passwordValidationError, setPasswordValidationError] = useState("");
    const [conpasswordValidationError, setConPasswordValidationError] = useState("");
    useEffect(() => {
        if (state?.userdata) {
            setData(state?.userdata)
        }
        else {
            setData(profileData)
        }
    }, [profileData, state])

    function checkValidation() {
        // Reset all error states and hidden classes first
        setUser_NameValidationError('');
        setPasswordValidationError('');
        setConPasswordValidationError('');

        document.querySelector('.oldpassword-error')?.classList.add('hidden');
        document.querySelector('.newpassword-error')?.classList.add('hidden');
        document.querySelector('.conpassword-error')?.classList.add('hidden');

        let isValid = true;

        // Validate Old Password
        if (oldPassword.trim() === "") {
            setUser_NameValidationError('Please enter old password');
            document.querySelector('.oldpassword-error')?.classList.remove('hidden');
            isValid = false;
        }

        // Validate New Password
        if (newPassword.trim() === "") {
            setPasswordValidationError('Please enter new password');
            document.querySelector('.newpassword-error')?.classList.remove('hidden');
            isValid = false;
        }

        // Validate Confirm Password
        if (confirmPassword.trim() === "") {
            setConPasswordValidationError('Please confirm your password');
            document.querySelector('.conpassword-error')?.classList.remove('hidden');
            isValid = false;
        } else if (newPassword !== confirmPassword) {
            setConPasswordValidationError('Passwords do not match');
            document.querySelector('.conpassword-error')?.classList.remove('hidden');
            isValid = false;
        }

        return isValid;
    }
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission

        // Clear previous errors
        setError('');

        // Perform validation
        if (checkValidation()) {
            setLoading(true);

            const formData = {
                user_id: data?._id,
                name: data?.name,
                user_name: data?.user_name,
                user_type: data?.user_type,
                old_password: oldPassword,
                new_password: newPassword,
                con_password: confirmPassword,
                master_id: data?.master_id,
                masters: data?.masters
            };

            try {
                const response = await dispatch(changePasswordAsync(formData)).unwrap();
                NotificationManager.success(response.message, '', 1000);

                // Reset form and log out
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
                if (data?.user_name == userdata?.user_name) {
                    dispatch(logout());
                }
                else {
                    setOpenEdit(false)
                }
            } catch (error) {
                // Handle specific error scenarios
                NotificationManager.error(error.message || 'Failed to change password', '', 3000);
            } finally {
                setLoading(false);
            }
        }
    }
    return (
        <>
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 relative mt-[20px] lg:mt-[15px]  mx-[.5rem]  px-[15px] ' >
                    <div className='col-span-12 '>
                        <div className='col-span-12 lg:col-span-9 '>
                            <div className='grid grid-cols-12'>
                                <div className='col-span-12 mb-[1.5rem]'>
                                    <div className='relative flex flex-col min-w-[0] text-[#212529] [word-wrap:break-word] bg-[#fff] bg-clip-border border-[1px]  border-[#0000002d] rounded-[.375rem]'>
                                        <div className='bg-[linear-gradient(#022c43,_#18b0c8)] text-[#ffffff] font-bold text-[0.938rem] px-[10px] py-[5px] [word-wrap:break-word] rounded-t-[3px]'>
                                            <span className='text-[#ffffff] font-bold text-[0.938rem]  py-[5px] [word-wrap:break-word]'>Account Details</span>
                                        </div>
                                        <div className='py-[1.25rem] px-[.5rem]'>
                                            <div className=''>
                                                <dl className='grid grid-cols-12'>
                                                    <dt className="col-span-12 lg:col-span-3 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] font-bold text-[0.813rem]">Name</dt>
                                                    <dd className='col-span-12 lg:col-span-9 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] text-[0.813rem]'>{data?.user_name}</dd>
                                                    <dt className="col-span-12 lg:col-span-3 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] font-bold text-[0.813rem]">Commission</dt>
                                                    <dd className='col-span-12 lg:col-span-9 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] text-[0.813rem]'>{data?.commission}</dd>
                                                    <dt className="col-span-12 lg:col-span-3 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] font-bold text-[0.813rem]">Currency</dt>
                                                    <dd className='col-span-12 lg:col-span-9 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] text-[0.813rem]'> INR</dd>
                                                    <dt className="col-span-12 lg:col-span-3 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] font-bold text-[0.813rem]">Partnership</dt>
                                                    <dd className='col-span-12 lg:col-span-9 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] text-[0.813rem]'>  {data?.partnership} </dd>
                                                    <dt className="col-span-12 lg:col-span-3 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] font-bold text-[0.813rem]">Mobile Number</dt>
                                                    <dd className='col-span-12 lg:col-span-9 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] text-[0.813rem]'> {data?.phone} </dd>
                                                    <dt className="col-span-12 lg:col-span-3 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] font-bold text-[0.813rem]">Password</dt>
                                                    <dd className='col-span-12 lg:col-span-9 pb-[15px] px-[10px] mb-[15px] border-b-[1px] border-b-[#ccc] text-[0.813rem]'>
                                                        <span className='mr-4'>*********</span>
                                                        <button className='!text-[#000]' onClick={() => setOpenEdit(true)}>
                                                            <span className='flex items-center gap-1 text-[black] hover:text-[#09437f]'>Edit <TfiPencilAlt /></span>
                                                        </button>
                                                        <Modal className='password-model  relative top-1 lg:top-7 lg:!w-[34vw]'
                                                            footer={[
                                                                <div className='col-span-12 gap-2 flex flex-shrink-0 flex-wrap items-center justify-end p-[1rem] border-t-[1px] border-t-[#dee2e6]'>
                                                                    <button type='submit ' className='text-white bg-[linear-gradient(#022c43,_#18b0c8)] hover:!bg-transparent  border-[1px]   text-[.875rem] rounded-[.25rem] px-[10px] py-[5px]   '
                                                                        onClick={handleSubmit}
                                                                    >
                                                                        Confirm
                                                                    </button>
                                                                    <button className='text-[#23282c] bg-[#c8ced3]  hover:text-inherit border-[#c8ced3] text-[.875rem] rounded-[.25rem] inline-block px-[10px] py-[5px] font-normal leading-normal text-center no-underline align-middle border-[1px] border-[solid] border-[#6c757d] [transition:color_.15s_ease-in-out,_background-color_.15s_ease-in-out,_border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out]'
                                                                        onClick={() => {
                                                                            setOpenEdit(false)
                                                                            setOldPassword('')
                                                                            setNewPassword('')
                                                                            setConfirmPassword('')
                                                                            setUser_NameValidationError('')
                                                                            setPasswordValidationError('')
                                                                            setConPasswordValidationError('')
                                                                        }}
                                                                    >
                                                                        No
                                                                    </button>
                                                                </div>
                                                            ]}
                                                            mask={false} open={openEdit} >
                                                            <div className='grid grid-cols-12'>
                                                                <div className='col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] rounded-t-[5px] h-[35px] bg-[linear-gradient(#022c43,_#18b0c8)] text-[#ffffff] flex flex-shrink-0 items-center justify-between'>
                                                                    <h5 className='text-[0.938rem] font-bold mb-0 leading-normal'>Change Password</h5>
                                                                    <button type="button" onClick={() => {
                                                                        setOpenEdit(false)
                                                                        setOldPassword('')
                                                                        setNewPassword('')
                                                                        setConfirmPassword('')
                                                                        setUser_NameValidationError('')
                                                                        setPasswordValidationError('')
                                                                        setConPasswordValidationError('')
                                                                    }} >
                                                                        <span className='text-[1.3125rem] font-bold'>×</span>
                                                                    </button>
                                                                </div>
                                                                <div className='col-span-12 !bg-[#ffffff] !text-[#23282c] relative flex-auto p-4'>
                                                                    <div className='grid grid-cols-12 lg:gap-x-6 '>
                                                                        <div className='col-span-12 lg:col-span-6'>
                                                                            <div className='mb-4 !text-[#23282c]'>
                                                                                <label className='inline-block mb-[.5rem] !text-[#23282c]' for="oldPassword">Old Password </label>
                                                                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                                                                    <Input.Password id='oldPassword' name='oldPassword'
                                                                                        onChange={(e) => setOldPassword(e.target.value)}
                                                                                        value={oldPassword}
                                                                                        required className='antd-password' placeholder="Old Password.." />
                                                                                    <span className="absolute top-[40px] oldpassword-error hidden  text-[0.813rem] text-[red] leading-[14px]">
                                                                                        <div className='leading-[14px] '>{user_nameValidationError}</div>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-span-12 lg:col-span-6'>
                                                                            <div className='mb-4 !text-[#23282c]'>
                                                                                <label className='inline-block mb-[.5rem] !text-[#23282c]' for="newPassword">New Password  </label>
                                                                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                                                                    <Input.Password id='newPassword' name='newPassword'
                                                                                        value={newPassword}
                                                                                        onChange={(e) => setNewPassword(e.target.value)} required className='antd-password' placeholder="New Password.." />
                                                                                    <span className="absolute top-[40px] newpassword-error hidden  text-[0.813rem] text-[red] leading-[14px]">
                                                                                        <div className='leading-[14px] '>{passwordValidationError}</div>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-span-12 lg:col-span-6'>
                                                                            <div className='mb-4 !text-[#23282c]'>
                                                                                <label className='inline-block mb-[.5rem] !text-[#23282c]' for="confirmPass">Confirm Password  </label>
                                                                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                                                                    <Input.Password id='confirmPass' name='confirmPass'
                                                                                        value={confirmPassword}
                                                                                        onChange={(e) => setConfirmPassword(e.target.value)} required className='antd-password' placeholder="Confirm Password.." />
                                                                                    <span className="absolute top-[40px] conpassword-error hidden  text-[0.813rem] text-[red] leading-[14px]">
                                                                                        <div className='leading-[14px] '>{conpasswordValidationError}</div>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </Modal>
                                                    </dd>
                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        </>
    );
}

export default MyAccount;
